<div class="flex flex-col items-center justify-center">
  <div class="flex flex-col w-full h-full gap-20">
    <h1 class="text-28">{{title}}</h1>
    <p style="max-width: 500px">{{message}}</p>
    <tandem-loading-container></tandem-loading-container>
  </div>
</div>
